/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';

	// ストーリー関連リンク設定
	const setPurposeNews = () => {
		const category = $('.rt_cf_n_category_code').text();
		const storyLinkBlock = $('.js-storyLink_block');
		// JSONデータ取得
		const getJSONNews = () => {
			const JSONURL = '/ajax/about/story/detail/' + category + '.json';
			return $.getJSON(JSONURL);
		};
		// ストーリー関連リンク生成
		getJSONNews().then((data) => {
			for (let i = 0; i < data.rt_bn_news.length; i++) {
				const storyData = data.rt_bn_news[i];
				let storyElem = ''
				storyElem += '<li class="pure-u-1-4 pure-u-lg-1-1 space-u-40-child">'
				storyElem += '<div class="about-story-voice_item-wrap">'
				if (storyData.rt_cf_n_href_story.target) {
					storyElem += '<a href="' + storyData.rt_cf_n_href_story.href + '" target="' + storyData.rt_cf_n_href_story.target + '" class="about-story-voice_item _sp_small ' + category + '">'
				}else {
					storyElem += '<a href="' + storyData.rt_cf_n_href_story.href + '" class="about-story-voice_item _sp_small ' + category + '">'
				}
				storyElem += '<figure class="about-story-voice_item-img">'
				storyElem += '<img src="' + storyData.cf_n_thum_img + '" alt="' + storyData.cf_n_thum_img_alt + '" title="' + storyData.cf_n_thum_img_title + '" class="width-u-100 rt_cf_p_thumb_img" loading="lazy">'
				if (storyData.rt_cf_n_icon_new != null) {
					storyElem += '<span class="about-story-voice_item-new" data-view="pc"><span>NEW</span></span>'
				}
				storyElem += '</figure>'
				storyElem += '<div class="about-story-voice_item-content" data-view="pc">'
				storyElem += '<div class="about-story-voice_item-head">'
				storyElem += '<span class="about-story-voice_item-num mr15">Vol.' + storyData.cf_n_number + '</span>'
				storyElem += '<span class="about-story-voice_item-num_txt">' + storyData.cf_n_category.cf_nc_name + '</span>'
				storyElem += '</div>'
				storyElem += '<h3 class="about-story-voice_item-name _no_lead mt30">' + storyData.cf_n_title + '</h3>'
				storyElem += '</div>'
				storyElem += '</a>'
				storyElem += '<div class="about-story-voice_item _sp_small_content ' + category + '">'
				if (storyData.rt_cf_n_href_story.target) {
					storyElem += '<a href="' + storyData.rt_cf_n_href_story.href + '" target="' + storyData.rt_cf_n_href_story.target + '">'
				}else {
					storyElem += '<a href="' + storyData.rt_cf_n_href_story.href + '">'
				}
				storyElem += '<div class="about-story-voice_item-content" data-view="tablet,sp">'
				storyElem += '<div class="about-story-voice_item-head">'
				storyElem += '<span class="about-story-voice_item-num mr15">Vol.' + storyData.cf_n_number + '</span>'
				storyElem += '<span class="about-story-voice_item-num_txt">' + storyData.cf_n_category.cf_nc_name + '</span>'
				storyElem += '</div>'
				storyElem += '<h3 class="about-story-voice_item-name _no_lead mt20">' + storyData.cf_n_title + '</h3>'
				storyElem += '</div>'
				storyElem += '</a>'
				storyElem += '<ul class="about-story-voice_item-tags mt15 md-mt10 opacity">'
				if (storyData.cf_n_tags) {
					for (let j = 0; j < storyData.cf_n_tags.length; j++) {
						const tagData = storyData.cf_n_tags[j];
						storyElem += '<li class="about-story-voice_item-tag"><a href="'+ tagData.rt_cf_n_tags_story.href +'">' + tagData.rt_cf_n_tags_story.content + '</a></li>'
					}
				}
				storyElem += '</ul>'
				storyElem += '</div>'
				storyElem += '</div>'
				storyElem += '</li>'
				storyLinkBlock.append(storyElem)
			}
		});
	}

	setPurposeNews()


})(window.jQuery, window.FUNCTIONS);
